import { render } from "./MsgReceive.vue?vue&type=template&id=4c2c0bd0&scoped=true"
import script from "./MsgReceive.vue?vue&type=script&lang=js"
export * from "./MsgReceive.vue?vue&type=script&lang=js"

import "./MsgReceive.vue?vue&type=style&index=0&id=4c2c0bd0&lang=less&scoped=true"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2c0bd0"]])

export default __exports__